import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Welcome to the Invoice Application", -1)),
    _createVNode(_component_router_link, { to: "/dashboard" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Dashboard")
      ])),
      _: 1
    }),
    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_router_link, { to: "/about-me" }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("About Me")
      ])),
      _: 1
    }),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1))
  ]))
}